'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024$0024anon$00241 from "./app.localization.-App-Locale$$anon$1.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale() {
  $m_Lapp_localization_AppLocale$();
  return $t_Lapp_localization_AppLocale$__En;
}
export { $s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale as $s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale };
/** @constructor */
function $c_Lapp_localization_AppLocale$() {
  $n_Lapp_localization_AppLocale$ = this;
  $t_Lapp_localization_AppLocale$__En = new $j_app$002elocalization$002e$002dApp$002dLocale$0024$0024anon$00241.$c_Lapp_localization_AppLocale$$anon$1("En", 0);
  $s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
}
export { $c_Lapp_localization_AppLocale$ as $c_Lapp_localization_AppLocale$ };
$c_Lapp_localization_AppLocale$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_localization_AppLocale$.prototype.constructor = $c_Lapp_localization_AppLocale$;
/** @constructor */
function $h_Lapp_localization_AppLocale$() {
}
export { $h_Lapp_localization_AppLocale$ as $h_Lapp_localization_AppLocale$ };
$h_Lapp_localization_AppLocale$.prototype = $c_Lapp_localization_AppLocale$.prototype;
$c_Lapp_localization_AppLocale$.prototype.ordinal__O__I = (function(x) {
  return x.Lapp_localization_AppLocale$$anon$1__f__$ordinal$1;
});
var $d_Lapp_localization_AppLocale$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_localization_AppLocale$, "app.localization.AppLocale$", ({
  Lapp_localization_AppLocale$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_localization_AppLocale$ as $d_Lapp_localization_AppLocale$ };
var $n_Lapp_localization_AppLocale$;
function $m_Lapp_localization_AppLocale$() {
  if ((!$n_Lapp_localization_AppLocale$)) {
    $n_Lapp_localization_AppLocale$ = new $c_Lapp_localization_AppLocale$();
  }
  return $n_Lapp_localization_AppLocale$;
}
export { $m_Lapp_localization_AppLocale$ as $m_Lapp_localization_AppLocale$ };
var $t_Lapp_localization_AppLocale$__En = null;
function $u_Lapp_localization_AppLocale$__En(x) {
  $t_Lapp_localization_AppLocale$__En = x;
}
export { $t_Lapp_localization_AppLocale$__En as $t_Lapp_localization_AppLocale$__En, $u_Lapp_localization_AppLocale$__En as $u_Lapp_localization_AppLocale$__En };
//# sourceMappingURL=app.localization.-App-Locale$.js.map
